
import { store } from '@/store'
import { Device } from '@/store/types'
import { Getter } from 'vuex-class'
import { DeskData } from '@/datamodel/deskdata'
import { Options, Vue } from 'vue-class-component'
import { TableLimit } from '@/datamodel/types'
import { GAME_TYPE } from '@/utils/constants'
import { MemberLimit } from 'vue'
import { Prop } from 'vue-property-decorator'

@Options({})
export default class LimitDialogView extends Vue {
    isMobile = false

    @Getter('device') device!: Device
    @Getter('deskLimit') deskLimit!: MemberLimit
    @Prop({ default: undefined })
    gType!: string

    beforeMount(): void {
        this.isMobile = this.device.display === 1
    }

    mounted(): void {
        console.log(this.deskLimit.id)
    }

    closeDialog(): void {
        this.$emit('on-close')
    }

    redAndBlueLimit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.downLimit} - ${this.deskLimit.upLimit}`
        }

        return '0 - 0'
    }

    greenLimit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.tieDownLimit} - ${this.deskLimit.tieUpLimit}`
        }

        return '0 - 0'
    }

    super6Limit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.superSixDownLimit} - ${this.deskLimit.superSixUpLimit}`
        }

        return '0 - 0'
    }

    pairLimit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.pairDownLimit} - ${this.deskLimit.pairUpLimit}`
        }

        return '0 - 0'
    }

    bearEightLimit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.bearEightDownLimit} - ${this.deskLimit.bearEightUpLimit}`
        }

        return '0 - 0'
    }

    dragonSevenLimit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.dragonSevenDownLimit} - ${this.deskLimit.dragonSevenUpLimit}`
        }

        return '0 - 0'
    }

    bigTigerLimit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.bigTigerDownLimit} - ${this.deskLimit.bigTigerUpLimit}`
        }

        return '0 - 0'
    }

    littleTigerLimit(): string {
        if (this.deskLimit) {
            return ` ${this.deskLimit.smallTigerDownLimit} - ${this.deskLimit.smallTigerUpLimit}`
        }

        return '0 - 0'
    }

    get gameType(): string {
        const params = new URLSearchParams(window.location.search)
        const _gameType = params.get('gameType')

        if (_gameType) {
            return _gameType
        }

        if (this.gType) {
            return this.gType
        }

        return ''
    }
}
